// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__1f1QP","card-PADDED":"card_card-PADDED__3Hail card_card__1f1QP","content_above_footer":"card_content_above_footer__MDjXY"};